import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Megaphone } from "lucide-react";
import { MA, MetaWizard } from "@/components/ads/MetaWizard";

export const MetaAdButton = ({ assetId, className = "", label = "" }) => {
  const [busy, setBusy] = useState(false);
  const [init, setInit] = useState(null);
  const open = async () => {
    setBusy(true);
    try { const r = await axios.post(`${MA}/draft`, { asset_id: assetId }, { timeout: 90000 }); setInit(r.data); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid={`meta-ad-btn-${assetId}`} onClick={open} disabled={busy} title="Fă o reclamă Meta din această creativă" className={className}>
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Megaphone className="h-3.5 w-3.5" />}{label}
      </button>
      {init && <MetaWizard init={init} onClose={() => setInit(null)} />}
    </>
  );
};
